let omarr = [
  {
    name: 'OS County Series',
    id: 'uk-osgb10k1888',
    caption: 'Earliest, most detailed OS map edition covering all of GB',
    date: '1888-1913',
    description: `This collection of OS maps is the earliest, most detailed topographic mapping that covers all of Great Britain. This is our most popular option as in certain areas bodies of water are also coloured which produces an aestheticly pleasing map.`,
    zoom: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17],
    mime: 'jpg',
    extraid: 'Six_Inch_GB_WFS'
  },
  {
    name: 'OS Hills Edition',
    id: 'uk-osgb63k1885',
    caption: 'Features an unique early hill-shading technique to depict relief',
    date: '1885-1903',
    description: `This collection allows for a good general overview of the landscape, settlement patterns, roads, railways, parkland and woodland. It isn't as detailed as the County Series but uniquely features hill-shading which was produced with a second copper plate of brown or black hachures to depict relief, rather than the conventional contour lines of the 'Outline' edition.`,
    zoom: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],
    mime: 'png',
    extraid: 'OS_One_Inch_GB_Hills_WFS'
  },
  {
    name: 'Provisional Edition',
    id: 'uk-osgb25k1937',
    caption: 'The first civilian map series at medium scale that later lead to the modern Explorer and Outdoor Leisure maps.',
    date: '1937-1961',
    description: `Covers 80% of Great Britain, everywhere apart from the Scottish Highlands and Islands. This collection of maps is useful for showing rural and urban areas in much greater detail than the standard OS.`,
    zoom: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16],
    mime: 'jpg',
    extraid: 'OS_1_25K_Provisional_WFS'
  },
  {
    name: 'Ordnance Survey Seventh Series',
    id: 'uk-osgb63k1955',
    caption: 'The first civilian map series at medium scale that later lead to the modern Explorer and Outdoor Leisure maps.',
    date: '1955-1961',
    description: `Originally intended for a wide-range of outdoor and recreational purposes it features many touring and cycling routes which later became the basis for the moden Landranger OS map style. Also printed using six to ten colours which allows for a clear differentiation and display of topographic features, types of roads, railways, water, woodland, urban areas, land use, footpaths, and relief contours at 50 foot intervals.`,
    zoom: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15],
    mime: 'jpg',
    extrainfo: 'catalog_one_inch_7th_series'
  },
]